module.exports = __webpack_public_path__ + "img/contact6.0006c5d0.png";